import React from "react";

export default function useEventListener<K extends keyof WindowEventMap>(
  eventName: keyof WindowEventMap,
  handler: (event: WindowEventMap[K]) => void
) {
  React.useEffect(() => {
    window.addEventListener(eventName, handler);
    return () => window.removeEventListener(eventName, handler);
  }, [eventName, handler]);
}
